export default "__VITE_ASSET__CP7Ie7jN__"